import { render, staticRenderFns } from "./Section3.vue?vue&type=template&id=52ee0172&scoped=true"
import script from "./Section3.vue?vue&type=script&lang=js"
export * from "./Section3.vue?vue&type=script&lang=js"
import style0 from "./Section3.vue?vue&type=style&index=0&id=52ee0172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ee0172",
  null
  
)

export default component.exports